import React from 'react';
import { Wrapper } from 'components/theme/Wrapper';
import { MainTitle, P1 } from 'components/theme/Typography';
import styled from 'styled-components';
import MessageSent from 'assets/message-sent';

const RequestToBookWrapper = styled(Wrapper)`
  margin: auto;
`;

const Heading = styled(MainTitle)`
  font-weight: normal;
  margin-top: 24px;
  margin-bottom: 8px;
  padding-bottom: 0;
  font-size: 24px;
  line-height: 44px;
  text-align: center;
  display: block;
`;

const Center = styled.div`
  text-align: center;
`;

const IconWrapper = styled.div`
  padding-top: 64px;
`;

const RequestToBookConfirmation = () => {
  return (
    <RequestToBookWrapper>
      <Center>
        <IconWrapper>
          <MessageSent scale={6} />
        </IconWrapper>
        <Heading className="email-confirmation-heading">
          Thank you for your interest in Mandarin Oriental Exceptional Homes.
          Our team will respond to your request within 24 hours.
        </Heading>
        <P1 className="email-confirmation-text">
          If your request was sent on a UK public holiday or weekend, the team
          will respond to you on the next business day.
        </P1>
      </Center>
    </RequestToBookWrapper>
  );
};

export default RequestToBookConfirmation;
